import { proxy, useSnapshot } from 'valtio';
import { z } from 'zod';
import { ENVIRONMENT } from '@soundxyz/utils/const';
import { PersistenceStorage } from '@store/persistence';

// !!!Make sure to version bump whenever you change the schema!!!
const SCHEMA_VERSION = '1.0';
const NotificationSchema = z.object({
  lastReadTimestamp: z.number().optional(),
});

type NotificationStateType = {
  notificationStatus: z.infer<typeof NotificationSchema>;
  loading: boolean;
};

const notificationState = proxy<NotificationStateType>({
  notificationStatus: {},
  loading: false,
});

export const useNotificationState = () => useSnapshot(notificationState);

export const setNotificationStatusPersistence = ({
  lastReadTimestamp,
}: {
  lastReadTimestamp: number;
}) => {
  notificationState.notificationStatus.lastReadTimestamp = lastReadTimestamp;
};

export const NotificationStatusPersistence = PersistenceStorage({
  schema: NotificationSchema,
  key: `@soundxyz/notification-lastReadTimestamp-${
    ENVIRONMENT === 'production' ? '' : '-' + ENVIRONMENT
  }-${SCHEMA_VERSION}`,
});

if (typeof window !== undefined) {
  NotificationStatusPersistence.initialValue
    .then(data => {
      notificationState.loading = true;
      if (!data) {
        notificationState.loading = false;
        return;
      }
      Object.assign(notificationState.notificationStatus, data);
      notificationState.loading = true;
    })
    // eslint-disable-next-line no-console
    .catch(console.error);
}
